/**
 * AddSubscribersReportCtrl controller
 * Add/Edit Reports
 */

import { SUBSCRIBERS_REPORT_REPORTING_METHOD } from 'app/core/constants'
import moment from 'moment'
import { ascBy, lowerCaseProperty } from '../../app/helpers/object'

/**
 * AddSubscribersReportCtrl controller
 *
 * @class AddSubscribersReportCtrl
 * @memberof mwApp/reports
 * @see mwApp/reports
 *
 * @ngdoc controller
 * @name mwApp/reports.controller:AddSubscribersReportCtrl
 */
/* @ngInject */
export default function AddSubscribersReportCtrl ($scope, $location, ReportSubscribersSeed, commonData) {
  var vm = this

  /**
   * Listen tab event
   */
  $scope.$on('dispatch: subscribers_reports', function () {
    $scope.$broadcast('refreshTable')
  })

  /**
   * Report state model
   *
   * @memberof mwApp/reports.controller:AddSubscribersReportCtrl
   * @type {Object}
   */
  vm.report = new ReportSubscribersSeed()

  /**
   * Packages list
   *
   * @memberof mwApp/reports.controller:AddSubscribersReportCtrl
   * @type {Array}
   */
  vm.packages = []

  /**
   * Report types list
   *
   * @type {Object}
   */
  vm.subscribers_reporting_method = SUBSCRIBERS_REPORT_REPORTING_METHOD

  /**
   * Report types url list
   *
   * @type {Object}
   */
  vm.subscribers_reporting_url = {
    ACTIVE_SUBSCRIBERS: 'active',
    TOTAL_SUBSCRIBERS: 'total',
    EXPIRING_SUBSCRIBERS: 'expiring',
    ACTIVATIONS_OF_SUBSCRIBERS: 'activations',
    PRE_ACTIVE: 'pre-active'

  }

  /**
   * Load extra data [packages, type]
   */
  ReportSubscribersSeed.load('api/reports/subscribers/extra', {
    networks: []
  }).then((data) => {
    vm.packages = [...data.networks]
    vm.packages.sort(ascBy(lowerCaseProperty('name')))
    vm.packages = [{ id: null, name: 'All Organizations' }, ...vm.packages]
  })

  /**
   * Generate report
   *
   * @memberof mwApp/reports.controller:AddSubscribersReportCtrl
   */
  vm.generateReport = function () {
    vm.setDisable()
    vm.report
      ._save(
        report => { if (report.networks.find((network) => network.id === null)) { report.networks = [] } },
        'api/reports/subscribers/' + vm.subscribers_reporting_url[vm.report.reportType]
      )
      .then(function (response) {
        const id = response.data.id
          ? response.data.id
          : response.data.payload.id
        $location.hash('generated_reports')

        commonData.data.update('lastReport', id)

        vm.location.reload()
      })
      .finally(vm.unsetDisable)
  }

  // cache default handler for datepicker
  const changeHandler = () => {
    if (moment().diff(vm.report.$fromDateTime, 'days') <= 0) {
      vm.report.$fromDateTime = moment().subtract(1, 'day').toDate()
    }

    if (moment().diff(vm.report.$toDateTime, 'days') <= 0) {
      vm.report.$toDateTime = moment().subtract(1, 'day').toDate()
    }
  }

  /**
   * Datepicker default settings
   *
   * @memberof mwApp/reports.controller:AddSubscribersReportCtrl
   * @type {{format : string, changeHandler : AddSubscribersReportCtrl.dpCfg.changeHandler}}
   */
  vm.dpCfg = {
    format: 'dd.MM.yyyy',
    minDate: moment().subtract(1, 'day').endOf('day').subtract(2, 'year').add(1, 'seconds').toDate(),
    maxDate: moment().subtract(1, 'day').toDate(),
    changeHandler
  }

  /**
   * Change report type
   *
   * @memberof mwApp/reports.controller:AddSubscribersReportCtrl
   */
  vm.changeReportType = function () {
    const endDate = new Date()

    switch (vm.report.reportType) {
      case 'EXPIRING_SUBSCRIBERS':
        vm.report.$fromDateTime = moment().toDate()
        vm.report.$toDateTime = moment().toDate()

        vm.dpCfg.minDate = moment().toDate()

        endDate.setDate(endDate.getDate() + 730)
        endDate.setHours(23, 59, 59, 999)
        vm.dpCfg.maxDate = endDate

        vm.dpCfg.changeHandler = () => {
          const diffFrom = moment().diff(vm.report.$fromDateTime, 'days', true)
          const diffTo = moment().diff(vm.report.$toDateTime, 'days', true)

          if (diffFrom < -730 || diffFrom > 0) {
            vm.report.$fromDateTime = moment().toDate()
          }

          if (diffTo < -730 || diffTo > 0) {
            vm.report.$toDateTime = moment().toDate()
          }
        }
        break
      default:
        vm.report.$fromDateTime = moment().subtract(1, 'day').toDate()
        vm.report.$toDateTime = moment().subtract(1, 'day').toDate()

        vm.dpCfg.minDate = moment().subtract(1, 'day').endOf('day').subtract(2, 'year').add(1, 'seconds').toDate()
        vm.dpCfg.maxDate = moment().subtract(1, 'day').toDate()
        vm.dpCfg.changeHandler = () => {
          if (moment().diff(vm.report.$fromDateTime, 'days', true) > 730) {
            vm.report.$fromDateTime = moment().subtract(1, 'day').endOf('day').subtract(2, 'year').add(1, 'seconds').toDate()
          }

          changeHandler()
        }
        break
    }
  }

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/reports.controller:AddSubscribersReportCtrl
   */
  vm.openFrom = function () {
    vm.dpCfg.openedFrom = true
  }

  /**
   * Handle open "to" datepicker
   *
   * @memberof mwApp/reports.controller:AddSubscribersReportCtrl
   */
  vm.openTo = function () {
    vm.dpCfg.openedTo = true
  }

  $scope.$watch('vm.report.networks', () => {
    if (vm.report.networks.length > 1 && vm.report.networks.find(n => n.id === null)) {
      vm.report.networks = vm.report.networks.filter(n => n.id === null)
    }
  })
}
